import { Info } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { transparencia, avisoNoOficial } from "@/config/site";

const COMMITMENTS = [
  ["Te explicamos con palabras simples", "Sin tecnicismos. Si algo no queda claro, lo vemos de nuevo."],
  ["Escuchamos primero y recomendamos después", "Partimos por entender tu situación y la de tu familia."],
  ["Sin presiones: tú decides", "Te damos la información y el tiempo que necesites."],
  ["Si no encontramos una opción adecuada, te lo decimos", "Preferimos ser honestos antes que ofrecerte algo que no te sirve."],
];

export const HowWeWork = () => (
  <section id="como-trabajamos" data-testid="how-we-work-section" className="bg-[#0B3C5D] py-16 text-white sm:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <h2 className="mb-10 text-[30px] font-extrabold leading-tight tracking-tight sm:mb-14 sm:text-4xl lg:text-[44px]">Cómo trabajamos</h2>
      </Reveal>
      <div className="grid gap-x-10 gap-y-8 sm:grid-cols-2">
        {COMMITMENTS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.06}>
            <div className="border-t-2 border-[#1FA89A] pt-5" data-testid={`commitment-${i}`}>
              <h3 className="text-[21px] font-bold leading-snug">{t}</h3>
              <p className="mt-2 text-[17px] leading-relaxed text-[#D5E2EA]">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <div className="mt-12 flex gap-3 rounded-2xl bg-white/10 p-5 text-[17px] leading-relaxed" data-testid="transparency-note">
          <Info className="mt-0.5 h-6 w-6 shrink-0 text-[#5FD3C6]" aria-hidden="true" />
          <p><strong>{transparencia()}</strong> {avisoNoOficial}</p>
        </div>
      </Reveal>
    </div>
  </section>
);
